import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';

import { useConfigurationStatus } from 'hooks/ApiStatus';

import whiteLogo from 'assets/svgs/autoDBWhiteLogo.svg';

import {
  StyledSideMenu, Logo,
  MenuOption, Divider,
  MenuOptionWrapper,
  MenuOptionIcon, NotificationDot,
} from './styles';

const SideMenu = ({ routes }) => {
  const location = useLocation();
  const history = useHistory();

  const { lastImport, isPublishing, hasModifications } = useConfigurationStatus();

  const renderMenuOption = (option) => {
    const {
      name, hasDivider, icon, path, needImport, hasPublishNotifications,
      enableOnPublish,
    } = option;

    const handleOnClick = () => {
      history.push(path);
    };

    const disableRoute = (needImport && !lastImport) || (!enableOnPublish && isPublishing);

    const hasNotification = hasPublishNotifications && hasModifications;

    return (
      <MenuOptionWrapper key={`menuOption-${name}`}>
        <MenuOption
          active={path === location.pathname}
          disabled={disableRoute}
          onClick={handleOnClick}
        >
          <MenuOptionIcon src={icon} />
          <p>{name}</p>
          {hasNotification && <NotificationDot />}
        </MenuOption>
        {hasDivider && <Divider />}
      </MenuOptionWrapper>
    );
  };

  return (
    <StyledSideMenu>
      <Logo src={whiteLogo} alt="autoDB logo" />
      {routes.map(renderMenuOption)}
    </StyledSideMenu>
  );
};

SideMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

export default SideMenu;
